import httpClient from './http-client';

const endpoint = 'api/users';

const userService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  getCurrent: () => httpClient.get(`${endpoint}/current`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (user) => httpClient.post(`${endpoint}`, user),

  update: (user) => httpClient.put(`${endpoint}/${user.id}`, user),

  delete: (user) => httpClient.delete(`${endpoint}/${user.id}`),

  toggleStatus: (user) => httpClient.patch(`${endpoint}/${user.id}/toggle-suspend`),

  resetPassword: (user) => httpClient.post(`${endpoint}/${user.id}/reset-password`, user),

  changeCurrentUserPassword: (payload) => httpClient.put(`${endpoint}/current/password`, payload),
};

export default userService;
